<!-- BEGIN #app -->
<div id="app" class="app" [ngClass]="{
 'has-scroll' : appHasScroll,
    'app-sidebar-minified': appSettings.appSidebarMinified,
		'app-sidebar-fixed': !appSettings.appSidebarNone && appSettings.appSidebarFixed,
		'app-header-fixed': !appSettings.appHeaderNone && appSettings.appHeaderFixed,
    'app-without-sidebar': appSettings.appSidebarNone || appSettings.appEmpty,
    'app-without-header': appSettings.appHeaderNone || appSettings.appEmpty,
    'app-with-end-sidebar': appSettings.appSidebarEnd,
    'app-with-two-sidebar': appSettings.appSidebarTwo,
    'app-with-wide-sidebar': appSettings.appSidebarWide,
    'app-sidebar-end-toggled': appSettings.appSidebarEndToggled,
    'app-sidebar-mobile-toggled': appSettings.appSidebarMobileToggled,
    'app-content-full-height': appSettings.appContentFullHeight,
    'app-with-top-menu': appSettings.appTopMenu,
    'app-sidebar-end-mobile-toggled': appSettings.appSidebarEndMobileToggled,
    'app-gradient-enabled': appSettings.appGradientEnabled,
    'p-0': appSettings.appEmpty
}">

<sa-header 	(appSidebarMobileToggled)="onAppSidebarMobileToggled($event)" 
(appSidebarEndToggled)="onAppSidebarEndToggled($event)" 
(appSidebarEndMobileToggled)="onAppSidebarEndMobileToggled($event)" 
[appSidebarTwo]="appSettings.appSidebarTwo" 
*ngIf="!appSettings.appEmpty && !appSettings.appHeaderNone"></sa-header>

<!-- sidebar -->
<sa-navigation  
 (appSidebarMinifiedToggled)="onAppSidebarMinifiedToggled($event)" 
  	(appSidebarMobileToggled)="onAppSidebarMobileToggled($event)" 
  	[appSidebarTransparent]="appSettings.appSidebarTransparent" 
  	[appSidebarMinified]="appSettings.appSidebarMinified"
  	[appSidebarGrid]="appSettings.appSidebarGrid"
  	[appSidebarFixed]="appSettings.appSidebarFixed"
  	*ngIf="!appSettings.appSidebarNone && !appSettings.appEmpty"
 
 ></sa-navigation>

<div  class="app-content" id="content"   [@routerTransition]="getState(o)">

  <!-- <sa-layout-switcher *ngIf="canAccessThemes"></sa-layout-switcher> -->

  <!-- <sa-ribbon></sa-ribbon> -->

  <router-outlet #o="outlet"></router-outlet>

  
</div>

<sa-footer style="background-color: white;"></sa-footer>
</div>
<!-- <sa-shortcut></sa-shortcut> -->

